export const FILE_MSG_PREFIX = '##***file***##';
export const IMAGE_MSG_PREFIX = '##***image***##';
